var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"img"},[_c('div',{staticClass:"boutique"},[_c('h1',[_vm._v("BOUTIQUE")])]),_c('div',{staticClass:"txtttt"},[_vm._v(" Bienvenue sur la liste de nos stands de boutique ! ")])])])
}]

export { render, staticRenderFns }